// File: src/App.jsx
import React from "react";
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Page from './components/Page';
import Contact from './components/Contact';
import ThankYou from './components/ThankYou';
import OurServices from './emura-tech/pages/OurServices';
import Footer from './components/Footer';
import Value from "./emura-edition/pages/Value";
import OurLibrary from "./emura-edition/pages/OurLibrary";
import BookDetail from "./emura-edition/pages/BookDetail";
import OurVision from "./emura-tech/pages/OurVision";
import OurMission from "./emura-tech/pages/OurMission";

function App() {
    return (
        <div className="bg-black min-h-screen text-white font-sans flex flex-col min-h-screen">
            <Navbar />

            <div className="flex-grow">
                <Routes>
                    {/*<Route path="/" element={<Hero />} />*/}
                    <Route path="/" element={<OurServices />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/thank-you" element={<ThankYou />} />
                    <Route path="/:page" element={<Page />} />
                    <Route path="/our-vision" element={<OurVision />} />
                    <Route path="/our-goal" element={<Hero />} />
                    <Route path="/our-mission" element={<OurMission />} />
                    <Route path="/our-services" element={<OurServices />} />
                    <Route path="/editorial-line" element={<Value />} />
                    <Route path="/our-library" element={<OurLibrary />} />
                    <Route path="/book/:id" element={<BookDetail />} />
                </Routes>
            </div>

            <Footer />
        </div>
    );
}

export default App;
